import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class CountryService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/countries`, options);
  }
}

export default CountryService;
